import { sassmallRequest } from './client'

export function getSassmallWalletAccount() {
  return sassmallRequest<Record<string, any>>('/fees/wallet/account', { method: 'GET' })
}

export function getSassmallProfile() {
  return sassmallRequest<Record<string, any>>('/customer/profile', { method: 'GET' })
}

export function getSassmallProfileStatistics() {
  return sassmallRequest<Record<string, any>>('/customer/profile/statistics', { method: 'GET' })
}

export function updateSassmallProfile(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>('/customer/profile', { method: 'POST', body: payload })
}

export function pageSassmallWalletLedgers(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>('/wallet/ledgers/page', { method: 'POST', body: payload })
}

// The mobile wallet uses activity records (one row per business event),
// which include the payment/order metadata omitted by the legacy ledger API.
export function pageSassmallWalletActivities(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>('/wallet/activities/page', { method: 'POST', body: payload })
}

export function getSassmallWalletActivity(activityId: string) {
  return sassmallRequest<Record<string, any>>(
    `/wallet/activities/${encodeURIComponent(activityId)}`,
    { method: 'GET' },
  )
}
